const pl = {
  COMMON: {
    NEXT: 'Następny ',
    NEXT_PLURAL: 'Następne ',
    TOMORROW: 'jutro',
    DONT_KNOW: 'nie wiem',
    TODAY: 'dzisiaj',
    DAY: 'dzień',
    DAYS: 'dni',
    HOUR_SHORT: 'g',
    HOUR: 'godzina',
    HOURS_2_4: 'godziny',
    HOURS: 'godzin',
    MINUTE: 'minuta',
    MINUTES_2_4: 'minuty',
    MINUTES: 'minut',
    BOOK_REVIEW: 'Recenzja książki',
    ARTICLE: 'Artykuł',
    PODCAST: 'Podcast',
    WORKSHOPS: 'Warsztaty',
    WEBINAR: 'Webinar',
    CONFERENCE: 'Konferencja',
    LECTURE: 'Wykład',
    SEARCH: {
      CLOSE: 'Zamknij',
      TIP: 'Aby otworzyć wyszukiwarkę, naciśnij ctrl + s na klawiaturze. Aby zamknąć, naciśnij esc.',
      LABEL: 'Wyszukaj',
      PLACEHOLDER: 'Wpisz temat, który Cię interesuje...',
      NO_RESULTS: 'Nie znaleziono wyników dla frazy: @1',
      LOADING: 'Trwa wyszukiwanie...',
    },
  },
  COOKIES: {
    TITLE: 'Ciasteczkowy potwór już tu był!',
    MESSAGE: 'Moja strona www wykorzystuje "ciasteczka". Szczegółowe informacje znajdziesz w mojej %%polityce zarządzania ciasteczkami%%.',
    ACCEPT: 'Ok',
    NOT_ACCEPT: 'Nie pasuje mi to',
  },
  NOT_TRANSLATED: {
    TITLE: 'Ta strona dostępna jest tylko w języku angielskim',
    MESSAGE: 'Aktualnie pracuję nad jej tłumaczeniem!',
  },
  HEADER: {
    TITLE: 'Mateusz Jabłoński - Blog, programowanie, rozwój',
  },
  FOOTER: {
    TITLE: 'Mateusz Jabłoński - Blog, programowanie, rozwój',
    FUNDS_INFO: {
      MESSAGE: '%%5% wpłat%% na ',
      INFO: ' i ze sprzedaży kursów przekazuję do fundacji ',
      ENCOURAGEMENT: 'Ciebie też zachęcam!',
      LOGO_ALT: 'Logo Fundacji Radość z Uśmiechu',
      HELP_ACTION_LABEL: 'Wspomóż fundację',
    },
    SOCIAL_MEDIA: {
      TITLE: 'Zajrzyj na moje %%social media!%%',
    },
  },
  MENU: {
    HOME: 'Home',
    BLOG: 'Blog',
    ABOUT: 'O mnie',
    WORKSHOPS: 'Warsztaty',
    PODCAST: 'Podcast',
    CONTACT: 'Kontakt',
    MEMBER_AREA: 'Strefa kursanta',
    PRIVACY_POLICY: 'Polityka prywatności',
    COOKIES: 'Informacja o cookies',
    DOCS: 'Dokumenty',
  },
  HOME: {
    HERO: {
      FREE_CONTENT_ACTION: 'Zobacz bezpłatne materiały',
      ABOUT_ACTION: 'Moja idea',
    },
    LAST_ARTICLES: 'Ostatnie %%artykuły%%',
    LAST_ARTICLES_END: {
      TITLE: 'A to tylko ostatnie artykuły!',
      MESSAGE: 'Większą dawkę wiedzy znajdziesz na stronie bloga. Zapraszam serdecznie!',
      ACTION: 'Wszystkie',
    },
    ALL_ARTICLES: 'Wszystkie moje artykuły',
    LAST_PODCASTS: 'Ostatnie %%podcasty%%',
    ALL_PODCASTS: 'Wszystkie podcasty',
    WANT_TO_BE_A_GUEST: 'Chcę wystąpić w podcaście',
    RECOMMENDED_BOOKS: 'Polecane %%książki%%',
    MORE_BOOKS: 'Więcej książek',
    LAST_WORKSHOPS: 'Aktualnie dostępne ',
    LAST_WORKSHOPS_STRONG: 'warsztaty',
    NEXT_PODCAST: 'podcast',
    NEXT_ARTICLE: 'artykuł',
    NEXT_ARTICLE_SLIDE: 'Następny artykuł',
    PREV_ARTICLE_SLIDE: 'Poprzedni artykuł',
    LISTEN_PODCAST: 'Słuchaj mojego podcastu:',
    LISTEN_PODCAST_ON: 'Słuchaj podcastu @1 na @2',
    LAST_EVENTS: 'Najbliższe %%wydarzenia%%',
    NEXT_EVENT: 'wydarzenie',
    NEXT_EVENT_IN: 'Już za @1 @2',
    NEXT_EVENT_TODAY: 'Już dzisiaj',
    BOOKS: {
      NO_LINK: 'Brak recenzji',
      WITH_LINK: 'Przejdź do recenzji',
    },
    NEWSLETTER: {
      TITLE: 'Dołącz do newslettera i bądź na bieżąco %%za darmo!%%',
      DESCRIPTION: 'Dołącz bezpłatnie do mojego newslettera. Będziesz otrzymywać informacje o nowych artykułach, ciekawostki ze świata programowania i dużo praktycznych porad na temat własnego rozwoju.',
    },
  },
  NEWSLETTER: {
    EMAIL_REQUIRED: 'Pole email jest wymagane',
    EMAIL_PLACEHOLDER: 'Podaj adres e-mail',
    ACTION: 'Zapisz mnie do newslettera',
    WELCOME_EMAIL: {
      SUBJECT: 'Witaj na pokładzie!',
      TITLE: 'Cześć!',
      PARAGRAPH_1: 'bardzo się cieszę, że dołączyłeś(-aś) do mojego newslettera.',
      PARAGRAPH_2: 'Raz w miesiącu będę wysyłał konkretną, esencjonalną dawkę wiedzy z obszarów, którymi zajmuję się na co dzień - bez lania wody i bez marketingowego szumu.',
      PARAGRAPH_3: 'Praktycznych przemyśleń o architekturze, Node.js i TypeScript w wydaniu produkcyjnym, frontendowych niuansów a czasami - finansów, produktywności i budowania niezależności jako specjalista.',
      PARAGRAPH_4: 'Zależy mi na tym, żeby każdy mail dawał Ci jedną konkretną wartość: nową perspektywę, narzędzie, wzorzec albo przemyślenie, które możesz od razu wykorzystać w swojej pracy.',
      SIGNATURE: 'Do usłyszenia, Mateusz',
    },
    ERROR: 'Podany email jest błędny lub wcześniej został już zapisany w naszej bazie danych.',
    SUCCESS: 'Udało się! Twój adres email został zapisany poprawnie.',
  },
  BREADCRUMBS: {
    CONTACT: 'Kontakt',
    ABOUT: 'O mnie',
    WORKSHOPS: 'Warsztaty',
    BOOKS: 'Książki',
    DOCS: 'Dokumenty',
  },
  ABOUT: {
    MOTIVATOR: {
      TITLE: 'Chciałbym być %%bardzo dobry%% w tym, co robię',
      MESSAGE: 'moje doświadczenie pokazuje mi jak wiele udało mi się osiągnąć, a także jak dużo nadal przede mną.',
    },
    DOTTED_TITLE: 'Przestrzeń %%pomiędzy znakami%%',
    LAST_CONTENT: {
      TITLE: 'Ostatnie materiały',
      TEXT: 'Poniżej znajdziesz najnowsze przygotowane przeze mnie materiały. Zapraszam do zapoznania się z nimi. Mam nadzieję, że wyciągniesz z nich dużo wartości dla siebie.',
    },
    WHAT_CAN_I_TEACH_YOU: {
      TITLE: 'Czego mogę Cię nauczyć?',
      I_TEACH_ADULTS_KIDS_SUBTITLE: 'Uczę programować dzieci i dorosłych',
      I_TEACH_ADULTS_KIDS_TEXT: 'Nauczanie programowania dla osób dorosłych odbywa się za pośrednictwem szkół programowania, takich jak Kodilla lub prywatnie w formie %%mentoringu lub szkoleń i warsztatów%% (dla Sages, StacjiIT, Orb Experts czy Noble Prog). Mentoring to specyficzna forma współpracy, która wymaga od każdej ze stron pełnego zaanganżowania.',
      TOPICS_SUBTITLE: 'Na zajęciach ze mną poruszysz tematy związane z:',
      TOPICS: {
        0: 'szeroko pojętym programowaniem',
        1: 'dobrymi praktykami i jakością',
        2: 'testowaniem',
        3: 'technologiami frontendowymi',
        4: 'narzędziami i warsztatem programisty',
      },
      WORK_WITH_KIDS_TEXT: 'Praca z dziećmi opiera się przede wszystkim na pokazaniu <strong>nowego sposobu uczenia się</strong>, poznawaniu technologii, wskazywaniu możliwości i niebezpieczeństw, które związane są z branżą IT. Na zajęciach z programowania dzieci tworzą samodzielnie proste programy z wykorzystaniem najpopularniejszych języków programowania. <strong>Najmłodsze dzieci, z którymi pracuję mają 11 lat.</strong> Zajęcia odbywają się w małych maksymalnie 4 osobowych grupach lub indywidualnie.',
      TRAININGS_TEXT: 'Na szkoleniach i warsztatach ze mną możesz liczyć na dużo uśmiechu, zrozumienie, rzetelną wiedzę, ciekawe materiały dodatkowe i angażujące zadania.',
    },
    CURRENT: {
      READ: {
        TITLE: 'Aktualnie czytam',
        NO_ACTIVITY: 'Chwilowy brak aktywności',
      },
      LISTEN: {
        TITLE: 'Ostatnio słuchałem',
        NO_ACTIVITY: 'Chwilowy brak aktywności',
      },
    },
    STORY: {
      TITLE: 'Jak to się zaczęło?',
      INTRO: 'Programowaniem zacząłem się interesować już dawno temu. Mając zaledwie 12 lat wraz z dwójką moich przyjaciół snuliśmy marzenia o wielkich projektach IT, braliśmy udział w różnych konkursach informatycznych i świetnie się przy tym bawiliśmy.',
      BLOCKQUOTE: 'Nigdy nie przypuszczałem, że programowanie stanie się moją pasją i zawodem.',
      EPISODE_1_1: 'W 2011 roku życie pokierowało moją karierę w kierunku tworzenia stron internetowych.',
      EPISODE_1_2: 'Od samego początku czułem, że się w tym odnajduję, że sprawia mi to dużo radości, a osiągane efekty popychają mnie dalej - coś kazało mi zagłębiać się w ten temat i wyciągać z niego coraz więcej dla siebie.',
      EPISODE_1_3: 'Niewątpliwie dużą rolę w moim życiu odegrali moi pierwsi mentorzy i współpracownicy.',
      EPISODE_2_1: 'Kilka lat później postanowiłem spróbować swoich sił w edukacji. Na ścieżkę mentorską wstąpiłem pod koniec 2016 roku.',
      EPISODE_2_2: 'Od tamtego czasu nieustannie staram się rozwijać nie tylko swoje umiejętności techniczne, ale również miękkie - przemawianie, pisanie, rozmawianie.',
      EPISODE_2_3: 'Zrozumiałem jak ważną rolę pełni mentor - trener podczas każdej sesji mentorskiej, warsztatów czy szkoleń. Można być świetnym programistą i nie mieć zacięcia do uczenia innych.',
      PHOTO_1_CAPTION: 'To ja wraz ze znajomymi przed II LO. Rok 2008.',
      PHOTO_2_CAPTION: 'Pierwsze kroki z Wordpress i Magento. Rok 2011.',
      PHOTO_3_CAPTION: 'Szkolenie wewnętrzne w Sonalake. Rok 2020.',
    },
  },
  ARTICLE: {
    SUMMARY: {
      TITLE: 'Z tego artykułu dowiesz się:',
    },
    META: {
      PUBLICATION_DATE: 'Data publikacji',
      LEVEL: 'Poziom',
      PODCAST: 'Podcast',
      EPISODE: 'Odcinek',
      CATEGORY: 'Kategoria',
      READING_DATE: 'Data przeczytania',
      MY_RATE: 'Moja ocena',
    },
    BUY_COFFEE: {
      TITLE: 'Podoba Ci się to co robię?',
      MESSAGE: 'Wszystkie materiały na stronie są darmowe. Jeśli uznasz je za przydatne, rozważ proszę wsparcie mnie poprzez postawienie mi kawy. ;)',
      ACTION: 'Tak, stawiam Ci kawę!',
    },
    ACTIONS: {
      READ_MORE: 'Czytaj więcej',
    },
    SOURCES: 'Źródła',
    SHARE: 'Udostępnij ten artykuł:',
    UPDATE_NOTE: {
      TITLE: 'Aktualizacja z dnia @1',
    },
    AUTHOR: {
      TITLE: 'O autorze',
      YOU_WILL_FIND_ME: 'Znajdziesz mnie'
    },
    COMMENTS: {
      TITLE: 'Komentarze',
      ADD: 'Dodaj komentarz',
      NO_NAME: 'Anonimowy autor',
      FIRST_MESSAGE: 'Jeszcze nikt nic nie napisał, ale to znaczy że... możesz być pierwszy/pierwsza.',
      COMMENTING_TITLE: 'Komentujesz artykuł',
      BACK: 'Cofnij'
    },
    RELATED: {
      TITLE: 'Powiązane treści',
      TEXT: 'Jeżeli ten artykuł Cię zainteresował sprawdź inne materiały powiązane z nim tematycznie. Poniżej znajdziesz artykuły i odcinki podcastów mojego autorstwa oraz polecane przeze mnie książki, które rozszerzają ten temat.',
    },
  },
  ARTILES: {
    LOAD_MORE: 'Wczytaj więcej treści'
  },
  WORKSHOPS: {
    ACTIONS: {
      TAKE_PART: 'Weź udział',
      ALL: 'Wszystkie warsztaty',
    },
    PROGRAM: {
      TITLE: 'Program',
    },
    REVIEWS: {
      TITLE: 'Dołącz do grona zadowolonych uczestników moich warsztatów!',
      NO_REVIEWS: 'Aktualnie brak opinii o tych warsztatach.',
      ANONYMOUS_USER: 'Uczestnik warsztatów',
    },
    CREATING_APP_WITH_REACT: {
      TITLE: 'Tworzenie aplikacji z użyciem React',
      DESCRIPTION: 'Poznaj jedną z najpopularniejszych bibliotek na rynku. Podczas trzech dni warsztatów poznasz najlepsze praktyki tworzenia aplikacji z wykorzystaniem React.',
      LONG_DESCRIPTION: 'Podczas warsztatów uczestnicy nie tylko poznają kluczowe koncepty Reacta, ale przede wszystkim nauczą się budować aplikacje w sposób zgodny z najlepszymi praktykami rynkowymi. W trakcie pracy warsztatowej przejdziemy przez cały proces - od analizy wymagań, przez projekt architektury komponentów, aż po implementację funkcjonalności oraz zarządzanie stanem. Szczególny nacisk położymy na organizację kodu, reużywalność i optymalizację wydajności. Po zakończeniu szkolenia uczestnicy będą gotowi samodzielnie tworzyć rozbudowane interfejsy użytkownika oraz podejmować świadome decyzje projektowe w nowych i istniejących projektach Reactowych.',
    },
    WORDPRESS_BASICS: {
      TITLE: 'Wordpress - od instalacji do zarządzania',
      DESCRIPTION: 'Celem warsztatów jest pokazanie możliwości tworzenia prostych stron internetowych bez pisania kodu z wykorzystaniem systemu zarządzania treścią Wordpress. Umiejętności zdobyte podczas warsztatów pozwolą na budowanie stron www zarówno do celów prywatnych, jak i zawodowych.',
      LONG_DESCRIPTION: 'Warsztaty są skierowane do osób, które chcą szybko i skutecznie nauczyć się tworzenia stron internetowych bez konieczności pisania kodu. Uczestnicy poznają logikę działania WordPressa, nauczą się konfigurować motywy i wtyczki, zarządzać treściami oraz dbać o aktualność i bezpieczeństwo strony. Pracujemy na praktycznych przykładach, aby każdy mógł zbudować własną stronę od podstaw. Dzięki takiemu podejściu uczestnicy zyskają kompetencje potrzebne zarówno do tworzenia prostych serwisów dla siebie, jak i do rozwijania stron dla klientów, firm czy organizacji w sposób profesjonalny i łatwy w utrzymaniu.',
    },
    ADVANCED_NODEJS_WITH_TYPESCRIPT: {
      TITLE: 'Zaawansowany Node.js z TypeScript',
      DESCRIPTION: 'Poznaj zaawansowane techniki tworzenia aplikacji backendowych z wykorzystaniem Node.js i TypeScript. Podczas dwóch dni warsztatów dowiesz się jak budować skalowalne i wydajne serwisy internetowe.',
      LONG_DESCRIPTION: 'Szkolenie jest przeznaczone dla osób, które chcą wejść na wyższy poziom pracy z backendem w Node.js. Uczestnicy poznają zaawansowane techniki, które są stosowane w profesjonalnych zespołach, w tym wielowarstwową architekturę aplikacji, integrację TypeScriptu w dużych projektach, wzorce projektowe oraz podejście do skalowania usług. Pracujemy na realnych przykładach związanych z przetwarzaniem danych, obsługą asynchroniczności, worker threads, strumieniami oraz integracją z bazami danych. Dzięki temu po szkoleniu uczestnicy są w stanie tworzyć nowoczesne, wydajne i dobrze zaprojektowane serwisy backendowe, które sprawdzają się w środowiskach produkcyjnych.',
    },
    ELECTRONJS_DESKTOP_APPS: {
      TITLE: 'Budowanie aplikacji desktopowych w ElectronJS',
      DESCRIPTION: 'Poznaj podstawy tworzenia aplikacji desktopowych z wykorzystaniem Electron. W trakcie jednodniowych warsztatów dowiesz się, jak zorganizować projekt, integrować go z Node.js, tworzyć interfejs użytkownika i przygotować gotową aplikację do dystrybucji.',
      LONG_DESCRIPTION: 'Warsztaty wprowadzają uczestników w świat tworzenia aplikacji desktopowych z wykorzystaniem technologii webowych. Podczas dnia intensywnej pracy uczestnicy poznają architekturę ElectronJS, nauczą się skutecznie łączyć logikę Node.js z interfejsem tworzonym w HTML, CSS i JavaScript oraz opracują własną aplikację gotową do kompilacji dla różnych systemów operacyjnych. Warsztat koncentruje się na praktyce: od podstawowych mechanizmów IPC, przez zarządzanie oknami, po bezpieczeństwo i dystrybucję. Uczestnik kończy szkolenie z umiejętnością samodzielnego tworzenia i rozwijania desktopowych narzędzi wewnętrznych, prototypów oraz aplikacji komercyjnych.',
    },
    ADVANCED_TYPESCRIPT: {
      TITLE: 'Zaawansowane programowanie w TypeScript',
      DESCRIPTION: 'Poznaj kluczowe elementy języka TypeScript i naucz się projektować bezpieczny, typowany kod. W trakcie jednodniowych warsztatów omówimy system typów, pracę z interfejsami i klasami, projektowanie generyków oraz dobre praktyki stosowane w nowoczesnych aplikacjach JavaScript.',
      LONG_DESCRIPTION: 'Podczas szkolenia uczestnicy wejdą w głąb zaawansowanych mechanizmów systemu typów TypeScript. Omówimy praktyczne scenariusze związane z projektowaniem interfejsów, modelowaniem złożonych typów, budowaniem generycznych komponentów oraz tworzeniem API odpornych na błędy. Duży nacisk położymy na realne przykłady z dużych projektów, tak aby uczestnicy mogli świadomie wykorzystywać typowanie do zwiększania jakości i przewidywalności kodu. Po warsztatach uczestnicy posiadają umiejętność projektowania kodu, który jest skalowalny, łatwy w utrzymaniu i wspiera zespoły w pracy nad złożonymi aplikacjami front- i backendowymi.',
    },
    ADVANCED_JAVASCRIPT: {
      TITLE: 'Zaawansowane programowanie w Javascript',
      DESCRIPTION: 'Poznaj nowoczesne podejście do programowania w JavaScript. Podczas jednodniowych warsztatów omówimy najnowsze funkcje języka, bezpieczne i wydajne wzorce kodu, pracę z asynchronicznością oraz praktyczne techniki programowania funkcyjnego.',
      LONG_DESCRIPTION: 'Warsztat skupia się na współczesnych standardach języka JavaScript oraz technikach, które pozwalają pisać wydajny, czytelny i zrównoważony kod. Uczestnicy przeanalizują zaawansowane aspekty pracy z funkcjami, klasami, modułami oraz asynchronicznością, a także poznają wzorce i antywzorce stosowane w codziennej pracy programistycznej. W trakcie praktycznych ćwiczeń omówimy techniki optymalizacji kodu, debugowanie trudnych przypadków oraz sposoby budowania architektury modularnej. Po szkoleniu uczestnicy potrafią świadomie wykorzystywać pełnię możliwości nowoczesnego JavaScriptu w projektach o różnej skali.',
    },
    REACT_REDUX: {
      TITLE: 'Reaktywne programowanie aplikacji webowych w oparciu o React i Redux',
      DESCRIPTION: 'Poznaj solidne podstawy zarządzania stanem w aplikacjach React z wykorzystaniem Reduxa. W trakcie jednodniowych warsztatów omówimy architekturę unidirectional data flow, tworzenie reduktorów i akcji, pracę z middleware oraz techniki optymalizacji dużych projektów opartych o Redux.',
      LONG_DESCRIPTION: 'Warsztaty szczegółowo wprowadzają w świat zarządzania stanem w aplikacjach Reactowych z wykorzystaniem Reduxa. Uczestnicy nauczą się budować struktury akcji, reduktorów i store’ów w sposób skalowalny oraz pracować z middleware, narzędziami deweloperskimi i technikami optymalizacji. Przeanalizujemy przepływ danych w architekturze unidirectional data flow i pokażemy, jak wykorzystać go do kontroli złożonych procesów biznesowych. Po warsztatach uczestnicy potrafią projektować i rozwijać duże aplikacje, w których zarządzanie stanem jest przejrzyste, przewidywalne i łatwe w utrzymaniu — zarówno indywidualnie, jak i w większym zespole.',
    },
    TYPESCRIPT_PLAYWRIGHT: {
      TITLE: 'Automatyzacja testów funkcjonalnych aplikacji internetowych z użyciem Playwright i TypeScript',
      DESCRIPTION: 'Poznaj praktyczne podstawy automatyzacji testów end-to-end z wykorzystaniem Playwright. W trakcie jednodniowych warsztatów omówimy konfigurację środowiska, pisanie testów, pracę z lokalizatorami i interakcjami, a także bardziej zaawansowane funkcje, takie jak POM, mockowanie API czy generowanie raportów.',
      LONG_DESCRIPTION: 'Podczas warsztatów uczestnicy zdobędą praktyczne kompetencje w zakresie automatyzacji testów E2E z Playwright i TypeScript. Wspólnie zbudujemy od podstaw środowisko testowe, napiszemy zestawy stabilnych testów oraz omówimy techniki pracy z lokalizatorami, mockowaniem API, izolacją testów i kontrolą środowiska. Szczególny nacisk położymy na tworzenie testów zgodnych z wzorcami projektowymi i budowanie architektury POM, która skaluje się wraz z projektem. Po szkoleniu uczestnicy będą w stanie przygotować pełny proces automatyzacji testów, integrować go z CI/CD oraz skutecznie wykrywać regresje w aplikacjach webowych o różnej skali.',
    },
    VUE_ASTRO: {
      TITLE: 'Astro i Vue: Architektura, Hydratacja i Pragmatyczne projektowanie frontendu',
      DESCRIPTION: 'Podczas tego warsztatu uczestnicy poznają zaawansowane techniki tworzenia nowoczesnych aplikacji webowych z wykorzystaniem frameworków Astro i Vue. Omówimy architekturę aplikacji, strategie hydratacji oraz najlepsze praktyki projektowania interfejsów użytkownika.',
      LONG_DESCRIPTION: 'Poznaj zaawansowane techniki tworzenia aplikacji webowych z Astro i Vue. Warsztat obejmuje omówienie architektury aplikacji, strategii hydratacji oraz praktyczne podejście do projektowania interfejsów użytkownika. Uczestnicy nauczą się integrować komponenty Vue w środowisku Astro, optymalizować wydajność aplikacji oraz stosować najlepsze praktyki w tworzeniu responsywnych i skalowalnych interfejsów. Po zakończeniu warsztatu uczestnicy będą mogli samodzielnie budować nowoczesne aplikacje webowe, wykorzystując pełnię możliwości obu frameworków.',
    },
    GITHUB_COPILOT: {
      TITLE: 'GitHub Copilot w pracy programisty',
      DESCRIPTION: 'Poznaj praktyczne sposoby wykorzystania GitHub Copilot w codziennej pracy programistycznej. Podczas warsztatów omówimy pisanie skutecznych promptów, generowanie i refaktoryzację kodu, pracę z testami oraz zasady bezpiecznego używania AI w projekcie.',
      LONG_DESCRIPTION: 'Warsztat pokazuje, jak używać GitHub Copilot jako realnego wsparcia w pracy programisty, a nie tylko narzędzia do podpowiadania pojedynczych linii kodu. Uczestnicy nauczą się formułować kontekst dla AI, korzystać z Copilot Chat, przyspieszać analizę istniejącego kodu, generować testy, dokumentację i propozycje refaktoryzacji. Duży nacisk położymy na ocenę jakości wygenerowanych rozwiązań, kontrolę bezpieczeństwa, pracę z ograniczeniami narzędzia oraz dobre praktyki wdrażania Copilota w zespole. Po szkoleniu uczestnicy będą potrafili świadomie wykorzystywać AI w codziennym procesie wytwarzania oprogramowania.',
    },
  },
  WORKSHOP: {
    DURATION: 'Czas trwania',
    COST_PER_USER: 'Koszt na osobę',
    CITY_OR_REMOTE: 'Miasto / zdalnie',
    ASK_FOR_PRICE: 'Zapytaj o termin',
    GROSS: 'brutto',
    NET: 'netto',
    COST_NOTE: 'dla grupy min. 4 osób',
    AVERAGE_RATING: 'Ocena uczestników',
    AVERAGE_RATING_SHORT: '(średnia ocen)',
    BASED_ON_RESPONSES: 'Na podstawie @1 odpowiedzi',
    EDITIONS: 'Warsztaty, które',
    EDITIONS_STRONG: 'już za nami',
    EDITIONS_DESCRIPTION: 'Poniżej znajdziesz listę edycji warsztatów, które poprowadziłem. Każda z nich to nowa grupa, inne wyzwania i konkretne efekty.',
    OPEN_EDITION_PLACE: 'Warsztaty OPEN',
    PLANNED_EDITION: 'Szkolenie zaplanowane',
    TOTAL_EDITIONS: 'Łącznie edycji',
    UPCOMING_EDITIONS: 'Nadchodzące terminy',
    PAST_EDITIONS: 'Poprzednie edycje',
    AUDIENCE: {
      TITLE: 'Dla kogo jest',
      TITLE_STRONG: 'to szkolenie',
      DESCRIPTION: 'Ten warsztat najlepiej działa wtedy, gdy uczestnicy chcą przełożyć wiedzę na praktyczne decyzje projektowe i kod pisany w realnych warunkach.',
      FOR_TITLE: 'Szkolenie jest dla Ciebie jeśli',
      FOR_ITEMS: [
        'chcesz uporządkować wiedzę i zobaczyć, jak stosować ją w codziennej pracy',
        'pracujesz przy aplikacjach lub narzędziach, które muszą być czytelne, rozwijalne i testowalne',
        'lubisz praktyczne ćwiczenia, dyskusję o trade-offach i przykłady bliskie realnym projektom',
      ],
      NOT_FOR_TITLE: 'To nie jest najlepszy wybór jeśli',
      NOT_FOR_ITEMS: [
        'szukasz wyłącznie teoretycznego wykładu bez pracy warsztatowej',
        'potrzebujesz bardzo podstawowego wprowadzenia od zera do programowania',
        'oczekujesz gotowych recept bez omawiania kontekstu, ograniczeń i konsekwencji decyzji',
      ],
    },
    TRAINER: {
      EYEBROW: 'Prowadzący',
      TITLE: 'Mateusz',
      NAME: 'Jabłoński',
      DESCRIPTION: 'Senior Frontend Developer, trener i autor materiałów. Od 2016 roku prowadzę szkolenia z JavaScriptu, TypeScriptu, Reacta, testowania oraz narzędzi wspierających pracę programistów.',
      EXPERIENCE_VALUE: '14+',
      EXPERIENCE_LABEL: 'lat doświadczenia',
      TEACHING_SINCE_VALUE: '2016',
      TEACHING_SINCE_LABEL: 'od tego roku szkolę',
      RATING_LABEL: 'na podstawie @1 odpowiedzi',
      RATING_LABEL_WITHOUT_RESPONSES: 'średnia ocena prowadzącego',
      ACTION: 'Poznaj mnie lepiej',
    },
  },
  CONTACT: {
    FORM: {
      TITLE: 'Formularz kontaktowy',
      DESCRIPTION: 'Dla twojej wygody formularz skrócony jest do jak najmniejszej liczby punktów, tak abym jak najszybciej i jak najsprawniej skontaktował się z Tobą.',
      WANT_MORE: 'Chcesz przesłać więcej infomacji?',
      WANT_MORE_TEXT: 'Najszybciej odpowiadam na wiadomości wysłane za pomocą powyższego formularza. Czas oczekiwania na odpowiedź na zwykły mail może być delikatnie dłuższy. Ale obiecuję - nie będzie to zbyt długo. :)',
      WANT_MORE_ACTION: 'Napisz do mnie',
    },
    NEWSLETTER: {
      TITLE: 'Mój newsletter',
      MAIN_CONTENT_1: 'Dołącz bezpłatnie do mojego newslettera. Raz na dwa tygodnie otrzymasz ode mnie wiadomość z informacjami o nowych materiałach, które znajdziesz na mojej stronie. Będziesz nie tylko pierwszy, ale uzyskasz dostęp do ciekawostek, interesujących ofert i nie publikowanych wcześniej materiałów.',
      MAIN_CONTENT_2: 'Newsletter, podobnie jak większość materiałów na mojej stronie, jest całkowicie bezpłatny. Obiecuję nie spamować i wysłać to, co rzeczywiście może Ci się przydać.',
    },
  },
  POLL: {
    TITLE: 'Ankieta',
    DESCRIPTION: 'Poniższa ankieta dotyczy szkolenia "@1". Ankieta jest anonimowa. Ankieta składa się z 5 kroków. Każda odpowiedź ma dla mnie ogromną wartość, bo dzięki niej będę mógł poprawić jakość szkolenia. Dziękuję za poświęcony czas!',
    LOADING: 'Trwa ładowanie ankiety',
    PASSWORD_QUESTION: 'Podaj hasło dostępowe do ankiety',
    PASSWORD: 'Podaj hasło dostępowe',
    PASSWORD_VERIFICATION: 'Trwa weryfikacja hasła dostępowego',
    NEXT: 'Dalej',
    BACK: 'Wstecz',
    SUBMIT: 'Wyślij',
    STEP: 'Krok @1 z @2',
    THANKS: {
      TEXT_1: 'Dziękuję za Twój czas i szczere odpowiedzi. W ramach podziękowania chciałbym przekazać Ci kod uprawniający do 20% zniżki na zakup Twojej pierwszej przestrzeni hostingowej w mydevil.net.',
      TEXT_2: 'Podaj poniższy kod polecającego podczas zakładania konta w mydevil.net i ciesz się tańszą usługą hostingową.',
    },
    SELECT_YOUR_ANSWER: 'Wybierz swoją ocenę',
    WRITE_YOUR_COMMENT: 'Napisz swoją opinię',
    WRONG_EMAIL: 'Podany email nie jest prawidłowy',
    SUCCESS_MESSAGE: 'Twoje odpowiedzi zostały zapisane.',
    CLOSED: 'Ta ankieta została już zamknięta. Nie można już przesyłać odpowiedzi.',
    ERRORS: {
      SELECT_RATING: 'Wybierz swoją ocenę.',
      WRITE_OPINION: 'Napisz swoją opinię.',
      INVALID_EMAIL: 'Podany email nie jest prawidłowy.',
    },
    ANSWERS: {
      GOOD_OR_BAD: {
        ONE: 'Fatalnie',
        TWO: 'Kiepsko',
        THREE: 'Tak sobie',
        FOUR: 'Dobrze',
        FIVE: 'Bardzo dobrze',
      },
      KNOWLEDGE_NOTES: {
        ONE: 'Brak wiedzy',
        TWO: 'Niewielka wiedza',
        THREE: 'Coś tam wiem',
        FOUR: 'Ogarniam temat',
        FIVE: 'Profesjonalista / Profesjonalistka',
      },
    },
    AVERAGE_NOTES: {
      WOW: 'Wow! Bardzo sie cieszę, że doceniasz moją pracę! Będę wdzięczny, jeśli w kroku czwartym napiszesz co podobało Ci się najbardziej, a co mógłbym jeszcze poprawić. 😉',
      IAM_SORRY: 'Przykro mi, że nie udało mi się spełnić Twoich oczekiwań. Będę wdzięczny, jeśli w kroku czwartym opiszesz elementy, które wymagają poprawy. Każde szkolenie to nowe doświadczenie. Każda opinia to szansa na rozwój. 😉',
    },
    QUESTIONS: {
      TRAINER_PREPARATION: {
        TITLE: 'Jak oceniasz przygotowanie prowadzącego?',
        DESCRIPTION: 'W skali od 1 do 5, gdzie 1 to fatalnie, a 5 to bardzo dobrze.',
        INTERNAL_QUESTIONS: {
          TRAINER_KNOWLEDGE: 'Dysponował wiedzą w zakresie omawianych tematów',
          TRAINER_EXPERIENCE: 'Dysponował doświadczeniem w zakresie omawianych tematów',
          TRAINER_COMMUNICATION: 'Przekazywał informacje systematycznie i skutecznie',
          TRAINER_ENGAGEMENT: 'Był komunikatywny i zaangażowany',
          TRAINER_QUESTIONS: 'Starał się nie pozostawiać pytań bez odpowiedzi',
          TRAINER_OPENNESS: 'Był otwarty na potrzeby grupy',
          TRAINER_CULTURE: 'Cechowała go wysoka kultura osobista',
        }
      },
      WORKSHOPS: {
        TITLE: 'Jak oceniasz szkolenie?',
        DESCRIPTION: 'W skali od 1 do 5, gdzie 1 to fatalnie, a 5 to bardzo dobrze.',
        INTERNAL_QUESTIONS: {
          WORKSHOPS_CONTENT: 'Zagadnienia w programie szkolenia zostały właściwie dobrane',
          WORKSHOPS_REALIZATION: 'Program szkolenia został zrealizowany w odpowiednim stopniu',
          WORKSHOPS_DURATION: 'Czas trwania został dobrany do zawartości programu',
        }
      },
      YOUR_KNOWLEDGE: {
        TITLE: 'Jak oceniasz swój poziom wiedzy?',
        DESCRIPTION: 'W skali od 1 do 5, gdzie 1 to brak wiedzy, a 5 to profesjonalista / profesjonalistka.',
        INTERNAL_QUESTIONS: {
          YOUR_KNOWLEDGE_BEFORE: 'Jak oceniasz swój poziom wiedzy PRZED szkoleniem?',
          YOUR_KNOWLEDGE_AFTER: 'Jak oceniasz swój poziom wiedzy PO szkoleniu?',
          YOUR_KNOWLEDGE_USEFULNESS: 'Jak oceniasz przydatność wiedzy przekazanej na szkoleniu?',
        }
      },
      YOUR_OPINION: {
        TITLE: 'Co chciał(a)byś przekazać prowadzącemu?',
        DESCRIPTION: 'Będę wdzięczny za każdą opinię. Pozwolają mi one ulepszać moją pracę w przyszłości. Wprowadzać nowości i poprawiać błędy.',
        INTERNAL_QUESTIONS: {
          YOUR_OPINION_ABOUT_WORKSHOPS: 'Co wg Ciebie można poprawić / ulepszyć / zmienić lub co powinno pozostać bez zmian? Jak podobało Ci się szkolenie?',
          YOUR_OPINION_ABOUT_MATERIALS: 'Co myślisz o materiałach szkoleniowych? Prezentacji, gadżetach, certyfikatach itp.',
        },
      }
    },
    NEWSLETTER_OPTION: {
      TITLE: 'Newsletter',
      DESCRIPTION: 'Chcesz otrzymywać informacje o nowych szkoleniach i materiałach? Podaj swój adres email, a zostanie on dopisany do mojej listy mailingowej.',
      YOUR_EMAIL: 'Twój adres email',
    },
  },
  PODCAST: {
    MY_PODCASTS: {
      TITLE: 'Moje podcasty',
      META: {
        SEASON: 'Sezon',
        EPISODES: 'Odcinki',
      }
    },
    GUEST_PODCASTS: {
      TITLE: 'Gościnne podcasty',
    },
    COMMON: {
      LISTEN: 'Słuchaj',
      SOURCES_TITLE_DOUBLE: 'Nasz podcast znajdziesz',
      AUTHOR: 'Autor: @1',
      COMMENTS: 'Komentarze',
      READ_MORE: 'Czytaj więcej',
      TRANSCRIPTION: 'Transkrypcja',
    },
    PLAYER: {
      LOADING_FILE: 'Trwa ładowanie pliku audio',
      PLAY_PAUSE: 'Play / Pause',
    },
  },
  DOCS: {
    TITLE: 'Dokumenty',
    DESCRIPTION: 'W poniższej tabeli znajdziesz informacje o dokumentach prawnych dostępnych w moim serwisie. Dokumenty te zawierają informacje o sposobie działania niniejszej witryny.',
  },
  LEVELS: {
    0: 'Koder Nowicjusz',
    1: 'Skrypter Początkujący',
    2: 'Programista Praktykant',
    3: 'Kompilator Entuzjasta',
    4: 'Konstruktor Modułów',
    5: 'Architekt Algorytmów',
    6: 'Władca Pętli',
    7: 'Szaman Debugowania',
    8: 'Mistrz Bibliotek',
    9: 'Sędzia Kodu',
    10: 'Mistrz Polimorfizmu',
    11: 'Czarodziej Interfejsów',
    12: 'Inżynier Skalowalności',
    13: 'Guru Architektury',
    14: 'Mistrz Programowania',
  },
}

export default pl;
